<div class="confirm-modal">
  <img src="../../../../assets/img/demande_gratuit.png" alt="demande gratuit" />
  <p class="confirm-modal__message">
    {{ "MODALS.FIRST_DEMANDE.MESSAGE" | translate }}
  </p>
  <div class="confirm-modal__buttons">
    <app-button
      [innerText]="'MODALS.FIRST_DEMANDE.BUTTON' | translate"
      (onClick)="handleCancle()"
    ></app-button>
  </div>
</div>
